import {
  ApartmentRounded,
  CategoryRounded,
  DashboardRounded,
  DomainAddRounded,
  FolderCopyRounded,
  ForumRounded,
  HelpCenterRounded,
  InfoRounded,
  LocalPoliceRounded,
  PersonRounded,
  PollRounded,
  QuestionMarkRounded,
  VerifiedUserRounded,
} from "@mui/icons-material";
import { Chip } from "@mui/material";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Stack from "@mui/material/Stack";
import * as React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSidebarCounts } from "../context/SidebarCountsContext";

export default function MenuContent() {
  const navigate = useNavigate();
  const location = useLocation();
  const { counts } = useSidebarCounts();

  const userPermissions = JSON.parse(localStorage.getItem("permissions")) || [];

  const mainListItems = [
    {
      text: "Dashboard",
      icon: <DashboardRounded />,
      path: "/dashboard",
      permissions: [],
    },
    {
      text: "Categories",
      icon: <CategoryRounded />,
      path: "/categories",
      permissions: ["category-list"],
    },
    {
      text: "Users",
      icon: <PersonRounded />,
      path: "/users",
      permissions: ["user-list"],
    },
    {
      text: "Support Categories",
      icon: <CategoryRounded />,
      path: "/support-categories",
      permissions: ["support-category-list"],
      group: "Support",
    },
    {
      text: "Support",
      icon: <HelpCenterRounded />,
      path: "/supports",
      permissions: ["support-list"],
      group: "Support",
    },
    {
      text: "Contents",
      icon: <FolderCopyRounded />,
      path: "/contents",
      permissions: ["content-list"],
    },
    {
      text: "User Questions",
      icon: <QuestionMarkRounded />,
      path: "/questions",
      permissions: ["question-list"],
    },
    {
      text: "Forums",
      icon: <ForumRounded />,
      path: "/forums",
      permissions: ["forum-list"],
    },
    {
      text: "Polls",
      icon: <PollRounded />,
      path: "/polls",
      permissions: ["poll-list"],
    },
    {
      text: "Service Center Types",
      icon: <DomainAddRounded />,
      path: "/service-center-types",
      permissions: ["service-type-list"],
      group: "Service Centers",
    },
    {
      text: "Service Centers",
      icon: <ApartmentRounded />,
      path: "/service-centers",
      permissions: ["centers-list"],
      group: "Service Centers",
    },
    {
      text: "Roles",
      icon: <VerifiedUserRounded />,
      path: "/roles",
      permissions: ["role-list"],
      group: "Security",
    },
    {
      text: "Permissions",
      icon: <LocalPoliceRounded />,
      path: "/permissions",
      permissions: ["permission-list"],
      group: "Security",
    },
  ];

  const secondaryListItems = [
    {
      text: "Developer Company",
      icon: <InfoRounded />,
      path: "/developer-company",
      permissions: [],
    },
  ];

  const filteredMainListItems = mainListItems.filter(
    (item) =>
      item.text === "Dashboard" ||
      item.permissions.every((perm) => userPermissions.includes(perm)),
  );

  return (
    <Stack sx={{ flexGrow: 1, p: 1, justifyContent: "space-between" }}>
      <List>
        {filteredMainListItems.map((item, index) => (
          <ListItem
            key={index}
            disablePadding
            sx={{
              display: "block",
            }}
          >
            <ListItemButton
              onClick={() => {
                navigate(item.path);
              }}
              selected={location.pathname.startsWith(item.path)}
            >
              <ListItemIcon sx={{ fontSize: "16px" }}>{item.icon}</ListItemIcon>
              <ListItemText primary={item.text} />

              {counts[item.path.slice(1)] > 0 && (
                <Chip label={counts[item.path.slice(1)]} color="primary" />
              )}
            </ListItemButton>
          </ListItem>
        ))}
      </List>

      <List dense>
        {secondaryListItems.map((item, index) => (
          <ListItem key={index} disablePadding sx={{ display: "block" }}>
            <ListItemButton
              onClick={() => {
                navigate(item.path);
              }}
              selected={location.pathname.startsWith(item.path)}
            >
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Stack>
  );
}
